









import Vue from "vue";
import TheUserInfo from "./TheUserInfo.vue";

export default Vue.extend({
  name: "TheHeader",
  props: ["drawer"],
  components: { TheUserInfo },
});
